import axios from "axios";
import { getCookie , XSRFCOOKIE } from "@/lib/cookie";

/**
 *
 * @param val
 * @returns {Promise<unknown>}
 */
function cercaAeroporto(val){
    return new Promise((resolve,reject)=> {
            let cookieval = getCookie(XSRFCOOKIE);
            axios.get(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_URL_AEROPORTI,
                {
                    params: {"term": encodeURI(val)},
                    headers: {'X-CSRF-TOKEN': cookieval}
                }).then(res => {
                resolve(res.data.items);
            }).catch(err => {
                console.log(err);
                reject(err);
            })

    })
}

/**
 *
 * @param partenzaid
 * @param destinazioneid
 * @returns {Promise<unknown>}
 */
function getAeroporti(partenzaid,destinazioneid){
    return new Promise((resolve,reject)=>{
        let cookieval = getCookie(XSRFCOOKIE);
        axios.post(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_PRECOMP_AERO, {"puid":partenzaid,"duid":destinazioneid},
            {headers: {'X-CSRF-TOKEN': cookieval}}).then(res => {
             let out = {partenza:null,destinazione:null};
             if(res.data.partenza !== null) out.partenza = res.data.partenza;
             if(res.data.destinazione !== null) out.destinazione = res.data.destinazione;
             resolve(out)
        }).catch((err)=>{
            reject(err);
        });
    })
}

/**
 *
 * @returns {Promise<unknown>}
 */
function loadCompagnie(){
    return new Promise((resolve,reject)=>{
        let cookieval = getCookie(XSRFCOOKIE);
        axios.post(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_COMPAGNIE_URL,{},
            {headers:{'X-CSRF-TOKEN': cookieval}}).then(res => {
            resolve(res.data);
        }).catch((err)=>{reject(err);})
    });
}

export { cercaAeroporto , getAeroporti, loadCompagnie }